import axios from 'axios'
import Qs from 'qs'

export default {
  config () {
    return {
      mode: 'no-cors',
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      'paramsSerializer': function (params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  },
  request (method, headers, endpoint, data, params) {
    headers = Object.assign(this.config().headers, headers)
    return axios(
      Object.assign(this.config(),
        {
          method: method,
          headers: headers,
          url: endpoint,
          data: data,
          params: params
        }
      ))
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js